module.exports = __webpack_public_path__ + "static/media/b-img-6.477a9cf0.png";